export default "__VITE_ASSET__B3BZo0jE__"